import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="https://res.cloudinary.com/diat3n1ac/image/upload/v1772340205/The_Host_Bros_Logo_nj5kny.png"
                alt="The Host Bros"
                className="h-8 w-auto max-w-[140px] object-contain object-left"
              />
              <span className="ml-2 text-xl font-bold">The Host Bros</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Professional WordPress & E-commerce web hosting services with white-glove onboarding and migration, 
              free SSL certificates, and support. Your trusted partner for reliable hosting.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/nobigdealgroup/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.268 4.771 1.691 5.077 4.907.06 1.054.068 1.437.068 4.77 0 3.333-.008 3.717-.068 4.77-.299 3.225-1.825 4.638-5.077 4.907-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.85-.07-3.26-.269-4.771-1.691-5.077-4.907-.06-1.054-.068-1.437-.068-4.77 0-3.333.008-3.717.068-4.77.306-3.216 1.817-4.638 5.077-4.907 1.266-.058 1.644-.07 4.85-.07zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
          </div>

        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              {new Date().getFullYear()} The Host Bros. No Big Deal Group LLC. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 